// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1kFmc","inputDescription":"styles_inputDescription__3c4Yh"};